// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
interface RotatorImage {
    id: string;
    title: string;
    url: string;
    thumbnailUrl: string;
}

interface RotatorProps {
    images: RotatorImage[];
    onClick: (image: RotatorImage) => void;
}

class Rotator extends React.Component<RotatorProps, any> {
    _rotatorListRef = createRef<HTMLUListElement>();

    constructor(props: RotatorProps) {
        super(props);
    }

    get rotatorContainer(): JQuery<HTMLElement> {
        return $(this._rotatorListRef.current) as JQuery<HTMLElement>;
    }
    get rotatorControl(): any {
        return this.rotatorContainer.data("ejRotator");
    }

    private _updateRotatorControl = (props: RotatorProps) => {
        let rotator = this.rotatorControl;
        if (rotator) {
            rotator.destroy();
        }

        if (props.images) {
            let options: any = {
                slideWidth: "100%",
                slideHeight: "100%",
                frameSpace: 0,
                displayItemsCount: 1,
                navigateSteps: 1,
                enabled: true,
                isResponsive: true,
                showPager: true,
                showPlayButton: false,              
                animationType: "slide",
                pagerPosition: (ej as any).Rotator.PagerPosition.BottomRight
            }

            rotator = new (ej as any).Rotator(this.rotatorContainer, options);
        }
    }

    componentDidMount() {
        this._updateRotatorControl(this.props);
    }

    shouldComponentUpdate(): boolean {
        // Never update this component...
        return false;
    }

    componentDidUpdate(prevProps: RotatorProps) {
        this._updateRotatorControl(this.props);
    }

    componentWillUnmount() {
        this.rotatorControl.destroy();
    }

    render() {

        var imageList = null;

        if (this.props.images) {
            imageList = this.props.images.map((image) => {
                return (
                    //alt={image.title} title={image.title}
                    <li><img src={image.thumbnailUrl} className="rotator-image" title={image.title} onClick={() => { this.props.onClick(image) }} /></li>
                )
            });
        }
        return (
            <div className="rotator">
                <ul ref={this._rotatorListRef}>
                    {imageList}
                </ul>
            </div>
        )
    }
}

export default Rotator;